export default () => {
  for (const item of document.getElementsByClassName('print')) {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      window.print();
    });
  }
}
